import React, { useEffect, useRef, useState, useCallback } from 'react';
import { Box, Button, IconButton, CircularProgress } from '@mui/material';

import UIcomponent from './components/UIcomponents';
import ThreejsModule from './components/Modules/threejsModule';
import LoadingTextureComp from './components/ConfigurationComp/LoadingComps/LoadingTextureComp';
import InitLoadingComp from './components/ConfigurationComp/LoadingComps/InitLoadingComp';
import PortraitComp from './components/ConfigurationComp/LoadingComps/PortraitComp';
import { QueryClientProvider, QueryClient } from '@tanstack/react-query';
import AIOProvider from './AIOProvider';
import GeneratingComp from './components/ConfigurationComp/LoadingComps/GeneratingComp';
import ReactGA from 'react-ga4';

let threejsModule;
const queryClient = new QueryClient();

if (window.location.hostname === 'aioverse.aiomotors.com') {
  ReactGA.initialize('G-MXY3RC1CVS');
}

function App(props) {
  const urlParams = new URLSearchParams(window.location.search);
  const myParam = urlParams.get('fleet');

  const isFleet = props.configureData.fleet || myParam;

  const canvasRef = useRef();
  const [loading, setLoading] = useState(0);
  const [loaded, setLoaded] = useState(false);
  const loadingRef = useRef();
  const [loadingTexture, setLoadingTexture] = useState(true);
  const [isInterior, setIsInterior] = useState(false);

  const [generating, setGenerating] = useState(false);

  // console.log({ isFleet, myParam });
  // console.log(props.configureData);
  const [configureMode, setConfigureMode] = useState(null);

  const setLoadHandler = () => {
    loadingRef.current.style.opacity = 0;
  };

  const exportImages = () => {
    // props.threejsModule.renderPreview()

    // window.dispatchEvent

    // webxr-render-feature-image

    window.dispatchEvent(new CustomEvent('webxr-render-feature-image', {}));

    window.dispatchEvent(
      new CustomEvent('webxr-render-image', {
        detail: {
          vehicles: {
            car: true,
            truck: false,
            van: false,
          },
          filename: 'test',
        },
      })
    );

    // webxr-render-image
  };

  const videoEndHandler = (e) => {
    threejsModule.onVideoEnd();
  };

  // console.log(props.configureData)
  useEffect(() => {
    const newData = props.configureData;

    if (isFleet) {
      newData.carType = 'van';
    }

    threejsModule = new ThreejsModule({
      canvasRef,
      setLoading,
      configureData: newData,
      setConfigureData: props.setConfigureData,
      setLoadingTexture,
      setLoadHandler,
      setIsInterior,
      setConfigureMode,
      isFleet: props.configureData.isFleet,
      setGenerating,
    });
    threejsModule.init();
  }, []);

  return (
    <AIOProvider
      configureData={props.configureData}
      threejsModule={threejsModule}
    >
      <React.Fragment>
        <QueryClientProvider client={queryClient}>
          <Box
            ref={canvasRef}
            sx={{
              width: '100%',
              height: '100%',
              backgroundColor: '#f4f4f4',
              position: 'relative',
            }}
          ></Box>

          {/* <Button
            onClick={() => {
              setTimeout(() => {
                exportImages(true);
              }, 100);
            }}
            sx={{
              position: 'fixed',
              width: '120px',
              top: '20px',
              zIndex: '2500',
              left: 'calc(50% - 60px)',
              fontFamily: 'Mona Sans',
              backgroundColor: 'white',
              fontWeight: { xs: '800', sm: '600' },
            }}
          >
            Download
          </Button> */}

          {generating && <GeneratingComp />}

          {/* <GeneratingComp /> */}

          <UIcomponent
            configureMode={configureMode}
            setConfigureMode={setConfigureMode}
            reservationData={props.reservationData}
            setReservationData={props.setReservationData}
            isFleet={props.configureData.isFleet}
            isInterior={isInterior}
            setIsInterior={setIsInterior}
            setLoaded={setLoaded}
            configureData={props.configureData}
            threejsModule={threejsModule}
            setGenerating
          />
          {!loaded && (
            <Box
              onTransitionEnd={() => {
                setLoaded(true);
              }}
              ref={loadingRef}
              sx={{
                width: '100%',
                height: '100%',
                backgroundColor: '#f4f4f4',
                position: 'absolute',
                top: '0',
                zIndex: '1000',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                gap: '20px',
                transition: 'opacity 1s ease-out',
              }}
            >
              <InitLoadingComp loading={loading}></InitLoadingComp>
            </Box>
          )}

          {loadingTexture && <LoadingTextureComp />}

          <video
            onEnded={videoEndHandler}
            id='screen-video'
            muted
            playsInline
            style={{
              position: 'absolute',
              top: '0',
              width: '1px',
              opacity: '0',
              zIndex: '-1000',
            }}
            src=' '
          ></video>
        </QueryClientProvider>
      </React.Fragment>
    </AIOProvider>
  );
}

export default App;
